import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { InputWithLabel } from '@reveni-io/reveni-ui'

import { maxDelayDays, minDelayDays } from './constants'

const DelayDaysInput = ({ value, onChange, disabled, error }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <InputWithLabel
      label={t('Número de días')}
      value={value || ''}
      onChange={onChange}
      type="number"
      min={minDelayDays}
      max={maxDelayDays}
      fullWidth
      disabled={disabled}
      backgroundColor={theme.colors.background.primary}
      error={error}
      helperText={error ? t('El valor debe estar entre 1 y 30') : undefined}
    />
  )
}

export default DelayDaysInput
